/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The GrantedAuthority model module.
 * @module model/GrantedAuthority
 * @version v0
 */
export default class GrantedAuthority {
  /**
   * Constructs a new <code>GrantedAuthority</code>.
   * @alias module:model/GrantedAuthority
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>GrantedAuthority</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GrantedAuthority} obj Optional instance to populate.
   * @return {module:model/GrantedAuthority} The populated <code>GrantedAuthority</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GrantedAuthority();
      if (data.hasOwnProperty('authority'))
        obj.authority = ApiClient.convertToType(data['authority'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} authority
 */
GrantedAuthority.prototype.authority = undefined;

